import React,{ useState } from "react";
import { updateEgressGateway } from "../../../actions/actionEgressProvider";
import EgressGatewayForm from "../EgressGatewayForm/EgressGatewayForm";
import {useTranslation} from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowProgress } from '@fortawesome/pro-light-svg-icons/faArrowProgress';
import PageHeader, { parentRoutes } from "../../../components/Header/PageHeader";
import { Form } from "../../../components/Form/Form"

const parentRouteList = parentRoutes('/egress_providers')
const newRoutes = [
    ...parentRouteList.routes,
    {name: "generic.update",path:"/update_egress_provider",isActive: true},
];

export default function UpdateEgressGateway(props) {
    const [currentTab, setCurrentTab] = useState('form');
    const { t } = useTranslation('common');
    
    const tabList = [
        { name: 'buttons.Edit', key: 'form' },
    ]
    
    const userData = {
        egress_gateway_id: props.match.params.gateway_id,
        egress_provider_id: props.match.params.id
    }
    const onSuccess = () => {
        props.history.push(`/update_egress_provider/${props.match.params.id}?tab=gateway`);
    }

    return (
        <div>
            <PageHeader location={props.location} routes={typeof newRoutes !== 'undefined' ? newRoutes : null} title={t('egress_provider.update-egress-gateway')} icon={<FontAwesomeIcon icon={faArrowProgress} />} />
            <Form 
                {...props}
                tabList={tabList}
                currentTab={currentTab}
                setCurrentTab={setCurrentTab}
                userData={userData}
                section="egress_provider"
                type="update"
                dispatchFunc={updateEgressGateway}
                onSuccess={onSuccess}
                form={<EgressGatewayForm egressGatewayId={props.match.params.gateway_id}  {...props} />}
            />
        </div>

    )
}
